/**
 * api-keys.ts — thời hạn + trạng thái API key (Cài đặt → API key). Khớp backend api-key-service.ts.
 */
import { currentLocale, i18n } from '@/lib/i18n'

export const API_KEY_TTL_OPTIONS: { value: string; days: number | null; label: string }[] = [
  { value: '7', days: 7, get label() { return i18n.t('sharedMisc:apiKeys.ttl.days7') } },
  { value: '30', days: 30, get label() { return i18n.t('sharedMisc:apiKeys.ttl.days30') } },
  { value: '90', days: 90, get label() { return i18n.t('sharedMisc:apiKeys.ttl.days90') } },
  { value: '180', days: 180, get label() { return i18n.t('sharedMisc:apiKeys.ttl.months6') } },
  { value: '365', days: 365, get label() { return i18n.t('sharedMisc:apiKeys.ttl.year1') } },
  { value: 'never', days: null, get label() { return i18n.t('sharedMisc:apiKeys.ttl.never') } },
]
export const DEFAULT_API_KEY_TTL = '90'

export function ttlDaysOf(value: string): number | null {
  const opt = API_KEY_TTL_OPTIONS.find((o) => o.value === value)
  return opt ? opt.days : 90
}

export type ApiKeyState = 'active' | 'expiring' | 'expired' | 'revoked'

const DAY_MS = 24 * 60 * 60 * 1000

/** Trạng thái + dòng mô tả hạn dùng. "expiring" = còn ≤ 7 ngày. */
export function apiKeyStatus(
  k: { revokedAt?: string | null; expiresAt?: string | null },
  now: Date = new Date(),
): { state: ApiKeyState; text: string } {
  const fmt = (iso: string) => new Date(iso).toLocaleDateString(currentLocale())
  if (k.revokedAt) return { state: 'revoked', text: i18n.t('sharedMisc:apiKeys.revokedAt', { date: fmt(k.revokedAt) }) }
  if (!k.expiresAt) return { state: 'active', text: i18n.t('sharedMisc:apiKeys.ttl.never') }
  const left = new Date(k.expiresAt).getTime() - now.getTime()
  if (left <= 0) return { state: 'expired', text: i18n.t('sharedMisc:apiKeys.expiredAt', { date: fmt(k.expiresAt) }) }
  if (left <= 7 * DAY_MS) return { state: 'expiring', text: i18n.t('sharedMisc:apiKeys.expiringAt', { date: fmt(k.expiresAt), days: Math.ceil(left / DAY_MS) }) }
  return { state: 'active', text: i18n.t('sharedMisc:apiKeys.expiresAt', { date: fmt(k.expiresAt) }) }
}
